(() => {
  if (window.quantumPurchaseChatGuard) return;
  window.quantumPurchaseChatGuard = true;

  const mobile = window.matchMedia('(max-width: 899px)');
  const stateClass = 'quantum-chat-purchase-overlap';
  const purchaseSelector = '.qe-product .product-form__submit, .qe-product .wt-product__sticky-buy__button';
  let scheduled = false;
  let observedRoot;
  let observedActivator;
  const resizeObserver = new ResizeObserver(schedule);
  const shadowObserver = new MutationObserver(schedule);

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  function update() {
    scheduled = false;
    const root = document.querySelector('body > shopify-chat')?.shadowRoot;
    const activator = root?.querySelector('button[part~="activator"]');
    if (root && root !== observedRoot) {
      shadowObserver.disconnect();
      shadowObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      observedRoot = root;
    }
    if (activator && activator !== observedActivator) {
      resizeObserver.disconnect();
      resizeObserver.observe(activator);
      document.querySelectorAll(purchaseSelector).forEach(button => resizeObserver.observe(button));
      observedActivator = activator;
    }

    let overlaps = false;
    if (mobile.matches && activator && !document.body.classList.contains('page-overlay-cart-on')) {
      const chat = activator.getBoundingClientRect();
      overlaps = Array.from(document.querySelectorAll(purchaseSelector)).some(button => {
        const style = getComputedStyle(button);
        const rect = button.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 &&
          rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight &&
          rect.left < chat.right && rect.right > chat.left && rect.top < chat.bottom && rect.bottom > chat.top;
      });
    }
    if (document.body.classList.contains(stateClass) !== overlaps) {
      document.body.classList.toggle(stateClass, overlaps);
    }
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  mobile.addEventListener('change', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
